import { Box, TextField } from "@material-ui/core";
import { useTranslation } from "react-i18next";
import CustomDropdown from "src/components/customDropdown";

export const FusionForm = (props) => {
  const { disabled, appConf, handleChange, formData } = props;
  const { t } = useTranslation();
  let exome_fastq = {};
  Object.entries(appConf.entities.pipeline_classes["exome_fastq"])
    .filter(([key]) => key !== "nanopore")
    .map((val) => {
      exome_fastq = { ...exome_fastq, [val[0]]: t(val[1]) };
      return val;
    });

  const sequencers = appConf.entities.sequencers;
  if (sequencers.hasOwnProperty("nanopore")) {
    delete sequencers["nanopore"];
  }

  return (
    <>
      <Box minWidth="100%">
        <TextField
          label={t("Project Title")}
          name="name"
          variant="outlined"
          required
          disabled={disabled}
          onChange={handleChange}
          value={formData ? formData.name : ""}
        />
        <CustomDropdown
          name="sample_kind"
          formData={formData}
          labelTitle={t("Type")}
          values={{
            paired_end: t("Paired End"),
          }}
          disabled={disabled}
          changeHandler={handleChange}
          defaultIndex={1}
        />
        <CustomDropdown
          name="kit"
          formData={formData}
          labelTitle={t("Kit")}
          values={appConf.entities.kits}
          disabled={disabled}
          changeHandler={handleChange}
          searchable={true}
        />
        <CustomDropdown
          name="sequencer"
          formData={formData}
          labelTitle={t("Sequencer Machine")}
          values={sequencers}
          disabled={disabled}
          changeHandler={handleChange}
          defaultIndex={1}
        />
      </Box>
      <TextField
        fullWidth
        id="project-desc"
        name="description"
        value={formData.description ?? ""}
        label={t("Project Description")}
        placeholder={t("Describe your project (optional)")}
        multiline
        rows={4}
        variant="outlined"
        disabled={disabled}
        onChange={handleChange}
      />
    </>
  );
};
